export const INITIAL_COUNTDOWN_TIME = 30 * 60; // 30 minutes in seconds
export const SOLUTION_TIMER_KEY = "futurebility_solutionCountdownTimer";
export const REFLECTION_TIMER_KEY = "futurebility_reflectionCountdownTimer";
